import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TGetProjectListingAPIResponse, TGetProjectListingFilters, TProjectListing, TCreateNewProjectReduxParams, TGetProjectDetailsReduxParams, TProjectDetails, TEditProjectDetailsReduxParams, TGetProjectFilter } from '~types/feat/project';
import { TProjectReduxState } from '~types/redux/state';

import {
    MetalTypeEnum,
    ProjectAccStatusEnum,
} from '~utils/enums';

export const initialState: TProjectReduxState = {
    loadings: {
        getProjectListing: false,
        createNewProject: false,
        editProjectDetails: false,
        getProjectDetails: false,
        getProjectFilters: false,
    },
    projectListing: {
        index: 0,
        maxIndex: 0,
        filters: {
            projectName: '',
            status: '',
            dateFrom: '',
            dateTo: '',
            metalType: '',
        },
        data: [],
    },
    projectFilters: [],
    modals: {
        createNewProjectModalIsOpen: false,
        projectDetailsModalIsOpen: false,
        projectStatusProjectIsOpen: false,
        isEditing: false,
    },
    projectDetails: {
        projectId: 0,
        projectName: '',
        earmarkAmount: '',
        earmarkEndDate: '',
        description: '',
        status: ProjectAccStatusEnum.Active,
    },
    errors: {
        getProjectListing: '',
        createNewProject: '',
        editProjectDetails: '',
        getProjectDetails: '',
        getProjectFilters: '',
    },
};

const projectSlice = createSlice({
    name: 'project',
    initialState,
    reducers: {
        projectGetProjectListingAttempt: (state) => {
            state.loadings.getProjectListing = true;
            state.errors.getProjectListing = '';
        },
        projectGetProjectListingSuccess: (state, action: PayloadAction<TGetProjectListingAPIResponse>) => {
            state.loadings.getProjectListing = false;
            state.projectListing = {
                filters: state.projectListing.filters,
                ...action.payload,
            };
        },
        projectGetProjectListingFailure: (state, action: PayloadAction<string | undefined>) => {
            state.loadings.getProjectListing = false;
            if (action.payload) state.errors.getProjectListing = action.payload;
        },
        projectSetGetProjectListingFilters: (state, action: PayloadAction<TGetProjectListingFilters>) => {
            state.projectListing.filters = action.payload;
        },
        projectSetProjectListingIndex: (state, action: PayloadAction<{ index: number }>) => {
            state.projectListing.index = action.payload.index;
        },
        projectSetProjectListingData: (state, action: PayloadAction<TProjectListing[]>) => {
            state.projectListing.data = action.payload;
        },
        projectSetCreateNewProjectModalIsOpen: (state, action: PayloadAction<boolean>) => {
            state.modals.createNewProjectModalIsOpen = action.payload;
        },
        projectCreateNewProjectAttempt: (state, _action: PayloadAction<TCreateNewProjectReduxParams>) => {
            state.loadings.createNewProject = true;
            state.errors.createNewProject = '';
        },
        projectCreateNewProjectSuccess: (state) => {
            state.loadings.createNewProject = false;
        },
        projectCreateNewProjectFailure: (state, action: PayloadAction<string | undefined>) => {
            state.loadings.createNewProject = false;
            if (action.payload) state.errors.createNewProject = action.payload;
        },
        projectResetCreateNewProjectState: (state) => {
            state.loadings.createNewProject = initialState.loadings.createNewProject;
            state.errors.createNewProject = initialState.errors.createNewProject;
        },
        projectSetProjectDetailsModalIsOpen: (state, action: PayloadAction<boolean>) => {
            state.modals.projectDetailsModalIsOpen = action.payload;
        },
        projectSetProjectDetailsModalIsEditing: (state, action: PayloadAction<boolean>) => {
            state.modals.isEditing = action.payload;
        },
        projectSetStatusProjectModalIsOpen: (state, action: PayloadAction<boolean>) => {
            state.modals.projectStatusProjectIsOpen = action.payload;
        },
        projectResetProjectDetails: (state) => {
            state.projectDetails = initialState.projectDetails;
        },
        projectGetProjectDetailsAttempt: (state, _action: PayloadAction<TGetProjectDetailsReduxParams>) => {
            state.loadings.getProjectDetails = true;
            state.errors.getProjectDetails = '';
        },
        projectGetProjectDetailsSuccess: (state, action: PayloadAction<TProjectDetails>) => {
            state.loadings.getProjectDetails = false;
            state.projectDetails = action.payload;
        },
        projectGetProjectDetailsFailure: (state, action: PayloadAction<string | undefined>) => {
            state.loadings.getProjectDetails = false;
            if (action.payload) state.errors.getProjectDetails = action.payload;
        },
        projectEditProjectDetailsAttempt: (state, _action: PayloadAction<TEditProjectDetailsReduxParams>) => {
            state.loadings.editProjectDetails = true;
            state.errors.editProjectDetails = '';
        },
        projectEditProjectDetailsSuccess: (state) => {
            state.loadings.editProjectDetails = false;
        },
        projectEditProjectDetailsFailure: (state, action: PayloadAction<string | undefined>) => {
            state.loadings.editProjectDetails = false;
            if (action.payload) state.errors.editProjectDetails = action.payload;
        },
        projectResetEditProjectDetailsState: (state) => {
            state.loadings.editProjectDetails = initialState.loadings.editProjectDetails;
            state.errors.editProjectDetails = initialState.errors.editProjectDetails;
        },
        projectGetProjectFiltersAttempt: (state) => {
            state.loadings.getProjectFilters = true;
            state.errors.getProjectFilters = '';
        },
        projectGetProjectFiltersSuccess: (state, action: PayloadAction<TGetProjectFilter[]>) => {
            state.loadings.getProjectFilters = false;
            state.projectFilters = action.payload;
        },
        projectGetProjectFiltersFailure: (state, action: PayloadAction<string | undefined>) => {
            state.loadings.getProjectFilters = false;
            if (action.payload) state.errors.getProjectFilters = action.payload;
        },
    },
});

export default {
    actions: projectSlice.actions,
    reducers: projectSlice.reducer,
};
